<div class="error-page flex flex-col justify-center items-center gap-6">
  <mat-icon class="not-found">clear</mat-icon>
  <div>Unexpected error occurred.</div>
</div>
